import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { style, animate } from '@angular/animations';

@Component({
  selector: 'app-footer-de',
  templateUrl: './footer-de.component.html',
  styleUrls: ['./footer-de.component.scss']
})
export class FooterDeComponent implements OnInit {
  
  fadeInBottom = [
    style({opacity: 0, transform: 'translateY(30px)'}),
    animate('1000ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'translateY(0px)'}))
  ];

  constructor(public dataService: DataService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/footer-de/footer-de.component.ts